'use client'
import clsx from 'clsx'
import { useEffect, useState, type ComponentPropsWithRef } from 'react'
import { Toast } from './toast'
import { useToaster, type ToastData } from './toasts-context'

type ToasterProps = ComponentPropsWithRef<'div'>

const Toaster = (props: ToasterProps) => {
    const { className, ...otherProps } = props
    const [toasts, setToasts] = useState<ToastData[]>([])

    const { subscribe, remove } = useToaster()

    useEffect(() => {
        const { unsubscribe } = subscribe(setToasts)
        return () => {
            unsubscribe()
        }
    }, [subscribe])

    return (
        <div
            className={clsx(
                'pointer-events-none fixed right-0 bottom-0 left-0 z-99 flex flex-col items-center overflow-hidden lg:items-start',
                className,
            )}
            {...otherProps}
        >
            <div className="flex max-w-xs flex-col items-center lg:items-start">
                {toasts.map(({ content, id, type, variant, timeout }) => (
                    <Toast
                        type={type}
                        variant={variant}
                        key={id}
                        onClose={() => {
                            remove(id)
                        }}
                        duration={timeout}
                    >
                        {content}
                    </Toast>
                ))}
            </div>
        </div>
    )
}

Toaster.displayName = 'Toaster'

export { Toaster, type ToasterProps }
